import { Badge } from "@/components/ui/badge";
import { cn } from "@/lib/utils";

const STATUS_MAP = {
  draft:               { label: "Draft",             cls: "bg-stone-100 text-stone-700 border-stone-200" },
  awaiting_approval:   { label: "Awaiting approval", cls: "bg-amber-50 text-amber-800 border-amber-200" },
  approved:            { label: "Approved",          cls: "bg-emerald-50 text-emerald-800 border-emerald-200" },
  rejected:            { label: "Rejected",          cls: "bg-rose-50 text-rose-800 border-rose-200" },
  pending:             { label: "Pending",           cls: "bg-stone-50 text-stone-600 border-stone-200" },
};

export function StatusBadge({ status, className }) {
  const s = STATUS_MAP[status] || { label: status, cls: "bg-stone-100 text-stone-700 border-stone-200" };
  return (
    <Badge
      data-testid="expense-status-badge"
      variant="outline"
      className={cn(
        "rounded-full font-semibold text-[11px] tracking-wide uppercase px-2.5 py-0.5 border",
        s.cls,
        className,
      )}
    >
      {s.label}
    </Badge>
  );
}
